import React from "react";
import { useSelector } from "react-redux";
import Documentations from "../../service-steps/documentation/documentations";
import ReferralsAMR from "../../service-steps/education/referrals-amr";
import DocumentationCheckList from "../../service-steps/documentation/documentations-checklist";

const Documentation = () => {
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const { currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;

  const renderStep = () => {
    const subStep = currentSubStep === 0 ? 1 : currentSubStep;
    switch (subStep) {
      case 1:
        return <ReferralsAMR />;
      case 2:
        return <DocumentationCheckList />;
      case 3:
        return <Documentations />;
    }
  };
  return renderStep();
};

export default Documentation;
